export default (state) => state.customer.loaded
